import type { SimpleChanges } from '@angular/core';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { RtAnalyticsModule, TrackDirective } from '@core/analytics-legacy';
import type { TOfferKind, OfferStatus } from '@core/offers-types';
import { OfferKind } from '@core/offers-types';
import { OfferStatusIndicatorComponent } from '@core/user-interface-legacy';
import { getJobRouterLink } from '@recruitee/offers-util';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [OfferStatusIndicatorComponent, RtAnalyticsModule, RouterLink, TrackDirective],
  template: `
    @if (offer.kind !== OfferKind.TalentPool) {
      <rt-offer-status-indicator [offerStatus]="offer" margin-right-small-x />
    }
    <a
      [routerLink]="offerLink"
      [rtcAnalyticsTrack]="'[Jobs] OpenJob'"
      [rtcAnalyticsTrackData]="{ status: offer.status }"
      (click)="$event.stopImmediatePropagation()"
    >
      <span>{{ offer.title }}</span>
    </a>
  `,
  styleUrls: ['./offer-title-cell.component.less'],
  host: {
    '[class]': '"title"',
  },
  inputs: OfferTitleCellComponent.NgInputs,
})
export class OfferTitleCellComponent {
  public static NgInputs = ['offer' as const];

  protected readonly OfferKind = OfferKind;

  public offer: { kind: TOfferKind; status: OfferStatus; title: string; slug: string };

  protected offerLink: string[];

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.offer) {
      const isTalentPool = this.offer.kind === OfferKind.TalentPool;
      this.offerLink = isTalentPool
        ? ['/offers', this.offer.slug, 'filters']
        : getJobRouterLink(this.offer);
    }
  }
}
